<template>
    <div
        class="c-o-company-section c-o-company-section--references"
        id="reference-jobs"
    >
        <div
            class="c-o-company-section__inner c-o-company-section__inner--centered c-o-company-section__inner--no-padding-bottom"
        >
            <div class="c-o-company-section__main">
                <h2 class="c-o-company-section__title h2">Referensjobb</h2>
                <p class="c-o-company-section__body">
                    Här kan du se tidigare jobb som <b>{{ companyName }}</b> har
                    utfört.
                </p>
            </div>
        </div>
        <div
            class="c-o-company-section__inner c-o-company-section__inner--no-padding-top"
        >
            <div class="c-o-company-section__references">
                <div
                    v-for="(reference, index) in references"
                    :key="`reference-${index}`"
                    class="c-o-company-section__reference"
                >
                    <div
                        v-if="reference.Image"
                        class="c-o-company-section__reference-image"
                    >
                        <carousel
                            class="c-o-company-section__reference-image-carousel"
                            :altText="
                                `Referensjobb &quot;${reference.Title}&quot; utfört av ${companyName}`
                            "
                            :items="reference.Image"
                        ></carousel>
                    </div>
                    <div class="c-o-company-section__reference-content">
                        <h3 class="c-o-company-section__reference-title h3">
                            {{ reference.Title }}
                        </h3>
                        <p class="c-o-company-section__reference-body">
                            {{ reference.Text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from "../../atoms/AtomIcon.vue";
import Carousel from "../../molecules/MoleculeCarousel.vue";

export default {
    data() {
        return {
            showModal: false
        };
    },
    props: ["references", "companyName"],
    components: {
        Icon,
        Carousel
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanySectionReferences.vue